import { render, staticRenderFns } from "./QuestionPoolsView.vue?vue&type=template&id=01e0d8bd"
import script from "./QuestionPoolsView.vue?vue&type=script&lang=js"
export * from "./QuestionPoolsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports